import NewsletterTextBlock from '@/components/newsletter/blocks/Text.vue'
import NewsletterUnorderedListBlock from '@/components/newsletter/blocks/UnorderedList.vue'

export default {
    components: {
        NewsletterTextBlock,
        NewsletterUnorderedListBlock,
    },
    props: {
        block: { type: Object, required: true },
    },
}
